import { configureStore } from "@reduxjs/toolkit"
import { persistStore, persistReducer } from "redux-persist"
import rootReducer, { rootPersistConfig } from "appRedux/rootReducer"
import { authApi } from "appRedux/slices/authApiSlice"
import { userProfileApi } from "appRedux/slices/userApiSlice"
import { wishListApi } from "appRedux/slices/wishListApiSlice"
import { wishItemApi } from "appRedux/slices/wishItemApiSlice"
import { notificationApi } from "appRedux/slices/notificationApiSlice"
import { feedApi } from "appRedux/slices/feedApiSlice"
import { initApi } from "appRedux/slices/initApiSlice"
import { premiumApi } from "appRedux/slices/premiumApiSlice"
import { orderApi } from "appRedux/slices/orderApiSlice"
import { paymentApi } from "appRedux/slices/paymentApiSlice"

const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer) as typeof rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    })
      .concat(authApi.middleware)
      .concat(userProfileApi.middleware)
      .concat(wishListApi.middleware)
      .concat(wishItemApi.middleware)
      .concat(notificationApi.middleware)
      .concat(feedApi.middleware)
      .concat(initApi.middleware)
      .concat(premiumApi.middleware)
      .concat(orderApi.middleware)
      .concat(paymentApi.middleware)
})

const persistor = persistStore(store)

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch;
export { store, persistor }
